import { createAction } from 'redux-starter-kit';

/**
 * An action creator that puts email content in the store.
 * @param {object} emailContent object containing the email content and email type.
 * @example dispatch(putEmailContent(emailContent));
 */
export const putEmailContent = createAction('PUT_EMAIL_CONTENT');
export const putAllEmailContent = createAction('PUT_ALL_EMAIL_CONTENT');

/**
 * Adds the default email contetn to teh emailcontent map for a given emailType
 * @param {object} defaultContent object containing the email type and its default email content
 */
export const addDefaultContent = createAction('ADD_DEFAULT_CONTENT');
